export default endDate => ({
    countdown: {
        days: [0, 0],
        hours: [0, 0],
        minutes: [0, 0],
        seconds: [0, 0],
    },
    date: null,
    distance: null,
    now: null,
    remainingTime: null,

    init() {
        this.setupTimer(endDate)
    },

    setupTimer(endDate) {
        this.date = new Date(endDate).getTime()
        this.now = new Date().getTime()
        this.distance = this.date - this.now
        this.countdown.days = Math.floor(this.distance / (1000 * 60 * 60 * 24))
        this.countdown.hours = Math.floor((this.distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        this.countdown.minutes = Math.floor((this.distance % (1000 * 60 * 60)) / (1000 * 60))
        this.countdown.seconds = Math.floor((this.distance % (1000 * 60)) / 1000)
        setInterval(() => this.timer(), 1000)
    },

    timer() {
        this.now = new Date().getTime()
        this.distance = this.date - this.now
        this.countdown.days = Math.floor(this.distance / (1000 * 60 * 60 * 24))
        this.countdown.hours = Math.floor((this.distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        this.countdown.minutes = Math.floor((this.distance % (1000 * 60 * 60)) / (1000 * 60))
        this.countdown.seconds = Math.floor((this.distance % (1000 * 60)) / 1000)
        this.remainingTime = `${this.countdown.days}d ${this.countdown.hours}h ${this.countdown.minutes}m ${this.countdown.seconds}s`
        this.countdown.days = this.countdown.days.toString().padStart(2, '0').split('')
        this.countdown.hours = this.countdown.hours.toString().padStart(2, '0').split('')
        this.countdown.minutes = this.countdown.minutes.toString().padStart(2, '0').split('')
        this.countdown.seconds = this.countdown.seconds.toString().padStart(2, '0').split('')
    },
})
